import { CountryCode, isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js'

import { Sex } from '../@types'
import { AuthState } from '../context/auth'
import * as Auth from '../lib/auth'
import { StandardAccountFormValues } from '../screens/CreateAccountProfile/CreateAccountProfile'
import { BaseAccountFormValues } from '../screens/CreateFamilyProfile/CreateFamilyProfile'

export type B2BUserRegistrationData = {
  companySlug: string
  landingPageToken: string
}

export type BaseProfile = {
  firstName: string
  lastName: string
  dateOfBirth: string
  sex: Sex
  genderInfo: string | null
  cpf?: string
  nationalIdentificationNumber?: {
    documentNumber: string
    documentType: string
  }
}

export type Profile = {
  password: string
  email: string
  phone: string
  b2bCompanySlug?: string
  b2bToken?: string
} & BaseProfile

export const isUserAuthenticated = ({ profile }: Pick<AuthState, 'profile'>) => !!profile?.emrId

export const getCreateBaseAccountProfilePayload = (input: BaseAccountFormValues): BaseProfile => ({
  firstName: input.firstName,
  lastName: input.lastName,
  dateOfBirth: `${input.dateOfBirthYear}-${input.dateOfBirthMonth}-${input.dateOfBirthDay}`,
  sex: input.sex,
  genderInfo: input.genderInfo || null,
  cpf: input.cpf,
  nationalIdentificationNumber:
    input.document?.number && input.document?.type
      ? {
          documentNumber: input.document?.number,
          documentType: input.document?.type,
        }
      : undefined,
})

export const getCreateAccountProfilePayload = (
  input: StandardAccountFormValues,
  b2bData?: B2BUserRegistrationData
): Profile => ({
  ...getCreateBaseAccountProfilePayload(input),
  password: input.password,
  email: input.email,
  phone: input.phoneNumber,
  b2bCompanySlug: b2bData?.companySlug,
  b2bToken: b2bData?.landingPageToken,
})

export const doesPhoneAlreadyExists = async (phone: string, countryCode: CountryCode) => {
  if (!phone || !isValidPhoneNumber(phone, countryCode)) return false

  const phoneNumber = parsePhoneNumber(phone, countryCode).number
  const { data } = await Auth.register.phoneExists(phoneNumber)

  return !!data?.phoneExists
}
